import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ptBR from '@/_lang/pt-BR'
import en from '@/_lang/en'
import zhCN from '@/_lang/zh-CN'

Vue.use(VueI18n)

export function createI18n () {
  const messages = { pt_BR: ptBR, en, 'zh-CN': zhCN }
  const lang = localStorage.getItem('dev_lang') ? localStorage.getItem('dev_lang') : 'pt_BR'
  /* 让送货服务和送货订单页面嵌入的iframe中的语言与v3统一 */
  localStorage.setItem('lang', lang.toLowerCase().replace('_', '-'))
  return new VueI18n({
    locale: lang,
    fallbackLocale: lang,
    messages
  })
}
